import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export function ResetGameCommand(): void {
    gameState.newGame(Services.get(SlotBetService).getTotalStake());
    Services.get(TransactionService).setWinnings(0, 0).execute();
}
